export default (axios, baseURL) => async (params, clientSid, email, selectedCsvTypes) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/zip/hub-upload`;

  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    params,
    data: {
      notificationEmail: email,
      csvTypes: selectedCsvTypes
    }
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
